import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";

// Scorrimento fluido (lenis) inizializzato una sola volta dentro il Router.
// Con prefers-reduced-motion resta lo scorrimento nativo.
export const SmoothScroll = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (reduce) {
            window.scrollTo(0, 0);
            return;
        }

        const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
        window.__lenis = lenis;

        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);

        // Le ancore dell'header usano lo scroll fluido con offset per l'header fisso.
        const onClick = (e) => {
            const a = e.target.closest('a[href^="#"]');
            if (!a) return;
            const href = a.getAttribute("href");
            if (href.length < 2) {
                e.preventDefault();
                lenis.scrollTo(0);
                return;
            }
            const el = document.querySelector(href);
            if (el) {
                e.preventDefault();
                lenis.scrollTo(el, { offset: -76 });
            }
        };
        document.addEventListener("click", onClick);

        return () => {
            document.removeEventListener("click", onClick);
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = undefined;
        };
    }, []);

    // Cambio pagina: torna in cima immediatamente.
    useEffect(() => {
        if (window.__lenis) {
            window.__lenis.scrollTo(0, { immediate: true });
        } else {
            window.scrollTo(0, 0);
        }
    }, [pathname]);

    return null;
};
